import React, { createContext, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import Booking from './components/Booking/Booking';
import BookingDetails from './components/BookingDetails/BookingDetails';
import Create from './components/EmailAndPassword/Create';
import Guide from './components/Guide/Guide';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Hotels from './components/Hotels/Hotels';
import LogIn from './components/LogIn/LogIn';
import NotFound from './components/NotFound/NotFound';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';

export const UserContext = createContext();

function App() {
  const [loggedInUser, setLoggedInUser] = useState({});
  return (
    <div className="bg">
      <UserContext.Provider value={[loggedInUser, setLoggedInUser]} className="background">
      <div className="container" >
        <Router>
          <Header />
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/home">
              <Home />
            </Route>
            <Route path="/booking">
              <Booking />
            </Route>
            <Route path="/login">
              <LogIn />
            </Route>
            <Route path="/register">
              <Create />
            </Route>
            <PrivateRoute path="/hotel">
              <Hotels />
            </PrivateRoute>
            <PrivateRoute path="/guide">
              <Guide />
            </PrivateRoute>
            <Route path="/booking/:uniqueId">
              <BookingDetails />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Router>
      </div>
    </UserContext.Provider>
    <div style={{height:'200px'}}>

    </div>
    </div>
  );
}

export default App;
